import { AxiosResponse } from 'axios';
import ApiConstants from '../../../../../constants/api_constants';
import { request } from '../../../../../network/axiosInstance';

export class UserApiService {
  private readonly userBaseUrl: string;

  constructor() {
    this.userBaseUrl = ApiConstants().user;
  }

  async getMyUserProfile(): Promise<AxiosResponse> {
    const response = await request({
      method: 'GET',
      url: `${this.userBaseUrl}me`,
      requiresToken: true,
    });
    return response;
  }

  async updateMyUserProfile(json: string): Promise<AxiosResponse> {
    const response = await request({
      method: 'PATCH',
      url: `${this.userBaseUrl}career-status`,
      data: json,
      headers: {
        'Content-Type': 'application/json',
      },
      requiresToken: true,
    });
    return response;
  }
}
